import styled from 'styled-components';
import TimeFromCreation from './component';

export default styled(TimeFromCreation)`
  color: var(--grey700);
`;
